import PasswordInput from './password-input';
export default PasswordInput;
